import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { RegisterTypes } from 'models/User';

import {  register, RegisterParams } from 'store/modules/user/actions';

import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Props extends ParentProps {
    actions: {
        register: (params: RegisterParams) => Promise<any>;
    };
}

export interface ParentProps {
    onSuccess?: (response: any) => any;
    registerType: RegisterTypes;
    buttonProps: ButtonProps;
    googleLabel: string;
}


const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            register: bindActionCreators(register, dispatch),
        },
    };
};

export interface ErrorMessages {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    userAgrees: string;
}

Component.defaultProps = {};

export default connect(null, mapDispatchToProps)(Component);